module.exports = __webpack_public_path__ + "assets/images/rbyearend-08-desktop.jpg?v=975804f9";